<template>
    <div class="Minister-top information">
        <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">基本信息</div>
        </div>
        <div class="information_content">
            <div class="information_Mandarin">
                <ul>
                    <li :class="{ liactive: languagetype === 1 }" @click="language(1)">中文</li>
                    <li :class="{ liactive: languagetype === 2 }" @click="language(2, '英语')">英语</li>
                    <li :class="{ liactive: languagetype === 3 }" @click="language(3, '德语')">德语</li>
                    <li :class="{ liactive: languagetype === 4 }" @click="language(4, '法语')">法语</li>
                    <li :class="{ liactive: languagetype === 5 }" @click="language(5, '意大利语')">意大利语</li>
                    <li :class="{ liactive: languagetype === 6 }" @click="language(6, '日语')">日语</li>
                    <li :class="{ liactive: languagetype === 7 }" @click="language(7, '西班牙语')">西班牙语</li>
                </ul>
                <div class="translate">
                    <span>一键从{{ languageContent }}翻译</span>
                    <span>一键从中文翻译</span>
                </div>
            </div>
            <!-- //标题 -->
            <eTitle />

            <!-- 亮点 -->
            <Brightspot />

            <!-- 关键字 -->
            <Keyword />
            <div class="information_input margin-top1">
                <div class="information_Title">描述</div>
                <div class="input_el">
                    <div class="editor-container">
                        <!-- <markdown-editor
                            class="width97"
                            ref="markdownEditor"
                            v-model="content"
                            :options="{ hideModeSwitch: true, previewStyle: 'tab' }"
                            height="200px"
                        /> -->
                        <div class="Preservation" @click="baocuns">保存</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Brightspot from "./Essential_information/bright_spot"; //亮点
import Keyword from "./Essential_information/Keyword"; //关键字
import eTitle from "./Essential_information/eTitle"; //标题
export default {
    name: "essential_information",
    components: {
        Brightspot,
        Keyword,
        eTitle,
    },
    data() {
        return {
            content: "编辑器",
            languageContent: "英语",
            languagetype: 1,
        };
    },
    mounted() {},
    created() {},
    methods: {
        baocuns() {
            console.log(this.content);
        },
        language(index, text) {
            this.languagetype = index;
            this.languageContent = text;
        },
    },
};
</script>

<style lang="scss" scoped></style>
